const c = {
  name: "LpmEmea",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M36.1,11.9l-8.7,2.9
			c-0.7-1.1-1.8-1.7-3.1-1.8l-0.5-2.4C25.1,9.9,26,8.6,26,7c0-1-0.4-1.9-1-2.7L25.9,3C30.3,4.5,34,7.8,36.1,11.9z M24.5,18.9
			c-0.8,0.2-1.8-0.1-2.2-0.9C22.1,17.7,22,17.4,22,17c0-0.1,0-0.2,0-0.4c0.1-0.8,0.8-1.5,1.6-1.6c0.1,0,0.2,0,0.4,0
			c0.9,0,1.6,0.6,1.9,1.4c0.1,0.2,0.1,0.4,0.1,0.6C26,17.9,25.4,18.7,24.5,18.9L24.5,18.9z M21.9,13.6c-0.1,0.1-0.3,0.2-0.4,0.3
			c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.4c0,0.1-0.1,0.1-0.1,0.2
			c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.1,0.7
			c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0.1,0.4c0,0,0,0,0,0l-1.4,0.9c0,0,0,0,0,0c-0.1-0.1-0.3-0.3-0.5-0.4
			c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.4-0.2c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c0,0-0.1,0-0.1,0
			c-0.2,0-0.3-0.1-0.5-0.1c0,0-0.1,0-0.1,0l-0.5-2.4c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.2,0.4-0.3
			c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.3,0.4-0.4c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.4c0-0.1,0.1-0.1,0.1-0.2
			c0.1-0.1,0.1-0.2,0.2-0.4c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.2,0.1-0.4,0.1-0.7
			c0-0.2,0-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0,0-0.1l1.4-0.9c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.5,0.4
			c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.3,0.2,0.4,0.2c0,0,0.1,0,0.1,0.1c0.2,0.1,0.4,0.1,0.6,0.2c0,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.5,0.1
			c0,0,0.1,0,0.1,0l0.5,2.4c-0.1,0-0.1,0.1-0.2,0.1S21.9,13.6,21.9,13.6L21.9,13.6z M16,24c-0.2,0-0.3,0-0.5-0.1
			c-0.8-0.2-1.4-0.8-1.5-1.6c0-0.1,0-0.2,0-0.3c0-1,0.7-1.8,1.6-2c0.1,0,0.2,0,0.4,0c0.7,0,1.3,0.4,1.7,0.9c0.2,0.3,0.3,0.7,0.3,1.1
			C18,23.1,17.1,24,16,24z M14,14c-1.1,0-2-0.9-2-2c0-0.3,0.1-0.7,0.2-0.9c0.4-0.7,1-1.1,1.8-1.1c0.7,0,1.3,0.4,1.7,0.9
			c0.2,0.3,0.3,0.7,0.3,1.1c0,0.1,0,0.2,0,0.4c-0.1,0.8-0.8,1.4-1.6,1.6C14.3,14,14.1,14,14,14L14,14z M23.1,5.3
			C23.7,5.7,24,6.3,24,7c0,1-0.7,1.8-1.6,2c-0.1,0-0.2,0-0.4,0c-0.7,0-1.3-0.4-1.7-0.9C20.1,7.7,20,7.4,20,7c0-1.1,0.9-2,2-2
			C22.4,5,22.8,5.1,23.1,5.3z M23.8,2.4l-0.5,0.8C22.9,3.1,22.4,3,22,3c-2.2,0-4,1.8-4,4c0,0.4,0.1,0.8,0.2,1.2l-1.4,0.9
			C16,8.4,15,8,14,8c-1.1,0-2.2,0.5-2.9,1.3l-3.7-2C10.6,4,15.1,2,20,2C21.3,2,22.6,2.2,23.8,2.4L23.8,2.4z M6,8.8l4.1,2.3
			C10,11.3,10,11.7,10,12c0,2.1,1.7,3.9,3.8,4l0.5,2.4C13,19,12.2,20.2,12,21.7l-9.7,1.6C2.1,22.2,2,21.1,2,20
			C2,15.8,3.5,11.9,6,8.8L6,8.8z M2.8,25.2l9.6-1.6c0.4,0.8,1,1.5,1.7,1.9l-2.6,10.4C7.4,33.6,4.2,29.8,2.8,25.2z M13.3,36.7L16,26
			c2.2,0,4-1.8,4-4c0-0.4-0.1-0.8-0.2-1.2l1.4-0.9C22,20.6,23,21,24,21c0,0,0.1,0,0.1,0l4.3,14.9C25.9,37.3,23,38,20,38
			C17.6,38,15.4,37.5,13.3,36.7L13.3,36.7z M30.1,34.9L26,20.4c1.2-0.7,2-2,2-3.4c0-0.1,0-0.2,0-0.3l8.9-3c0.7,1.9,1.1,4,1.1,6.2
			C38,26.2,34.9,31.6,30.1,34.9L30.1,34.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as LpmEmea
};
